import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="center-load"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/landing" replace />;
  return children;
}
